import { render, staticRenderFns } from "./DollarMerchants.vue?vue&type=template&id=86a6f7ba"
import script from "./DollarMerchants.vue?vue&type=script&lang=js"
export * from "./DollarMerchants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports